import React, { useState, useRef, useEffect } from 'react';
import { Col } from 'react-bootstrap';
import { FaPhoneAlt } from 'react-icons/fa';
import { CPF_MASK } from 'v3/utils/masks';
import { getPhoneMask } from 'v3/utils/functions';
import { Modal, Button, Text, } from 'v3/components';
import ManualRegisterDriver from '../ManualRegisterDriver'
import DriverRegisterOcr from '../DriverRegisterOcr'


function CreateDriver({ isOpen, onClose }) {

  const manualRef = useRef(null);
  const ocrRef = useRef(null);

  const [manualRegister, setManualRegister] = useState(false)
  const [data, setData] = useState({})
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  async function handleSave() {
    if (manualRegister) {
      await manualRef.current?.save();
    } else {
      await ocrRef.current?.save();
    }
  }

  const handleClose = () => {
    onClose();
    setData({});
    setErrors({});
    setManualRegister(false);
  }

  useEffect(() => {
    setData({});
    setErrors({});
  }, [manualRegister])

  return (
    <>
      <Modal
        show={isOpen}
        handleClose={handleClose}
        heading={
          <div
            style={{
              alignItems: 'center',
              display: 'flex',
              gap: 16,
              justifyContent: 'space-between',
              paddingRight: 32,
              width: '100%',
            }}
          >
            <Text type="header" color="dark" weight="500">
              Cadastrar motorista
            </Text>
            <Button
              className="py-2"
              onClick={() => setManualRegister(!manualRegister)}
            >
              <Text weight="500" type="regular">
                {!manualRegister ? 'Cadastro manual' : 'Importar motorista'}
              </Text>
            </Button>
          </div>
        }
        body={
          <>
            {
              manualRegister ? (
                <ManualRegisterDriver
                  ref={manualRef}
                  props={data}
                  setProps={setData}
                  handleClose={handleClose}
                  loading={loading}
                  setLoading={setLoading}
                />
              ) : (
                <DriverRegisterOcr
                  ref={ocrRef}
                  data={data}
                  setData={setData}
                  handleClose={handleClose}
                  setSaveLoading={setLoading}
                  saveLoading={loading}
                  setErrors={setErrors}
                  errors={errors}
                />
              )
            }
          </>
        }
        footer={
          <Col
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: 8,
              marginTop: 16,
              marginBottom: 32,
            }}
          >
            <Button
              variant="secondary"
              onClick={handleClose}
              loading={loading}
            >
              <Text color="dark" type="regular">
                Voltar
              </Text>
            </Button>
            <Button
              variant="success"
              onClick={handleSave}
              loading={loading}
            >
              <Text weight={500} color="white" type="regular">
                Salvar
              </Text>
            </Button>
          </Col>
        }
      />
    </>
  );
}

export default CreateDriver;
